/**
 * @file BinsFilterBar.tsx
 * @description Фильтры справочника ячеек: поиск по адресу/подписи, склад и
 *   «Показывать архивные» (phase19.23, A4; вынесено из страницы в
 *   phase19.22 шаг 5, чтобы страница осталась раскладкой ≤200 строк).
 *
 * phase19.31 (зона «Склад», минимум): «Архивные» — пилюля-переключатель
 * кабинета вместо нативного чекбокса, высоты — из темы.
 */

import { FilterBar } from "../../ui/FilterBar";
import { FilterToggleChips } from "../../ui/FilterChips";
import { SearchInput } from "../../ui/SearchInput";
import { SelectField } from "../../ui/SelectField";
import type { WarehouseDto } from "../../../lib/api-wms";

interface Props {
  search: string;
  onSearchChange: (value: string) => void;
  warehouses: WarehouseDto[];
  warehouseId: string;
  onWarehouseChange: (id: string) => void;
  includeArchived: boolean;
  onIncludeArchivedChange: (value: boolean) => void;
}

export function BinsFilterBar({
  search,
  onSearchChange,
  warehouses,
  warehouseId,
  onWarehouseChange,
  includeArchived,
  onIncludeArchivedChange,
}: Props) {
  return (
    <FilterBar
      search={
        <SearchInput
          value={search}
          onChange={onSearchChange}
          placeholder="Адрес или подпись ячейки"
          ariaLabel="Поиск по ячейкам"
        />
      }
      // Телефон: пилюли — в шторке «Фильтры · N» (единое решение склада).
      chipsCollapse={{ activeCount: includeArchived ? 1 : 0, onReset: () => onIncludeArchivedChange(false) }}
      chips={
        <FilterToggleChips
          aria-label="Отбор ячеек"
          items={[{ key: "archived", label: "Архивные", pressed: includeArchived, onToggle: () => onIncludeArchivedChange(!includeArchived) }]}
        />
      }
    >
      <SelectField
        value={warehouseId}
        onChange={onWarehouseChange}
        options={
          warehouses.length === 0
            ? [{ value: "", label: "Складов нет" }]
            : warehouses.map((w) => ({ value: w.id, label: w.name }))
        }
        placeholder="— склад —"
        ariaLabel="Склад"
        className="w-full sm:w-[280px]"
      />
    </FilterBar>
  );
}
